export default __webpack_public_path__ + "static/report-content-09-665f5b2598c97b4423d896b14d73e84a.png";